<template>
  <div class="break section-block">
    <div class="section-block__title">Место работы</div>
    <div v-if="data && data.jobPlace" class="row-box">
      <WrapperField
        v-for="(value, index) in data.jobPlace"
        :key="value + index + Math.random()"
        :data="createDataField({
          fieldName: index, 
          fieldValue: value, 
          fieldGroup: 'jobPlace',
          fieldGroupEdit: data.jobPlace.orgName ? 'organization' : false,
        })"
      ></WrapperField>
    </div>
  </div>
</template>

<script>
import { createDataField } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
export default {
  name: 'JobPlace',
  components: {
    WrapperField,
  },
  props: ['data'],
  data: () => ({
    createDataField,
  }),
};
</script>

<style scoped>

</style>
